var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"personal-page-wrapper",class:_vm.rootLayoutClass},[_c('MobilePage',{attrs:{"personalInfo":_vm.personalInfo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }